import { getURLWithParams } from "utils/context";
import { useFetchMxfNestApi } from "hooks";

export const useRegimeIbsList = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams("regime-cbs-ibs/relations", params));
